import axios from "axios";

export function getIntegrators() {
  return axios({
    method: "get",
    url: "/api/v2/integrators",
  })
    .then((response) => response.data)
    .catch((response) => response.response.data);
}

export function getIntegratorCompanies(id) {
  return axios({
    method: "get",
    url: `/api/v2/integrators/${id}/companies`,
  })
    .then((response) => response.data)
    .catch((response) => response.response.data);
}

export function getCompanyUser(id, integratorId) {
  return axios({
    method: "get",
    url: `/api/v2/integrators/${integratorId}/users/${id}`,
  })
    .then((response) => response.data)
    .catch((response) => response.response.data);
}



// WEBPACK FOOTER //
// ./app/services/integrators/integrators.js